const ThemeChoose = () => import("../../customize/themeChoose/ThemeChoose.vue");
export default {
  components: { ThemeChoose },
  props: {},
  data() {
    return {
      userAccount: "",
    };
  },
  mounted() {
    let loginAccount = window.sessionStorage.getItem("loginAccount");
    if (loginAccount) {
      this.userAccount = loginAccount;
    }
    document.title = "资料库";
  },
  methods: {
    loginOut() {
      //退出功能
      //弹出确认对话框
      //用户点击确认，跳回用户登录页面，清除token
      this.$confirm("确定要退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "退出成功!",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
          //确认退出，清除token
          //window.sessionStorage.removeItem('token')
          window.sessionStorage.clear(); //退出后清空window.sessionStorage里的内容。
          //跳转登录页面(编程式导航)
          this.$router.push("/login");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
        });
    },
    toUrl(path) {
      console.log(path);
      let { indexProjectString } = this.$route.params;
      console.log(indexProjectString);
      this.$router.push({
        name: path,
        params: {
          stype: "sandbox",
          indexProjectString,
        },
      });
    },
  },
  watch: {},
  destroyed() {},
};
//console.log(localStorage.getItem(ColorPicker));
